

























































































import {Component, Prop, Vue} from "vue-property-decorator";
import {CounterpartyType} from "@/constants/CounterpartyType";
import StaffRegistrationModal from "@/components/payroll/business/employments/employee/EmployeeRegistrationModal.vue";
import CompanySearch from "@/components/common/CompanySearch.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import PersonSearch from "@/components/payroll/business/employments/employee/PersonSearch.vue";
import CreatePersonRequestDTO from "@/dto/person/CreatePersonRequestDTO";
import PersonDTO from "@/dto/person/PersonDTO";
import RegisterContractorPayload from "@/components/payroll/business/employments/contractors/RegisterContractorPayload";
import {namespace} from "vuex-class";
import {ifValid} from "@/utils/ComponentUtils";
import Workspace from "@/dto/auth/Workspace";
import Workspaces from "@/state/Workspaces";
import CustomerAccounts from "@/dto/CustomerAccounts";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import CreateCompanyRequestDTO from "@/dto/company/CreateCompanyRequestDTO";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import ForeignContractorService
	from "@/components/payroll/business/employments/foreignContractors/ForeignContractorService";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import {PAY_PERIOD_TYPE_OPTIONS, PAY_TYPE_OPTIONS, PayType} from "@/constants/TarifficationConstants";
import Notifications from "@/state/Notifications";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import {ContractType, contractTypeOptions} from "@/constants/EmploymentType";

const AppModule = namespace("App");

@Component({
	methods: {contractTypeOptions: contractTypeOptions},
	components: {
		PortalRadio,
		BTPortalCollapse,
		PortalInput,
		PortalSelect,
		PortalCheckbox, PersonSearch, PortalDate, CompanySearch, StaffRegistrationModal},
	computed: {
		ContractType() {
			return ContractType
		},
		PayType() {
			return PayType
		},
		PAY_PERIOD_TYPE_OPTIONS() {
			return PAY_PERIOD_TYPE_OPTIONS
		},
		PAY_TYPE_OPTIONS() {
			return PAY_TYPE_OPTIONS
		},
		CounterpartyType() {
			return CounterpartyType
		}
	}
})
export default class ForeignContractorRegistrationModal extends Vue {
	private isOpen1 = false;
	private isOpen2 = false;
	private hasError = false;

	private payload: RegisterContractorPayload = new RegisterContractorPayload()

	private createPersonRequest: CreatePersonRequestDTO = new CreatePersonRequestDTO();
	private createCompanyRequest: CreateCompanyRequestDTO = new CreateCompanyRequestDTO();

	private workspace: Workspace = Workspaces.getCurrent;

	private message: string | null = null;

	private successful = false;

	@AppModule.Action
	private startLoading!: () => void

	@AppModule.Action
	private stopLoading!: () => void

	@Prop()
	private callback!: () => void;

	public mounted(): void {
		this.payload.employerId = this.workspace.id;
	}

	private applyCompanySelect(customer: CompanyDTO) {
		this.payload.contractorId = customer.id;
	}

	private applyPersonSelect(customer: PersonDTO) {
		this.payload.contractorId = customer.id;
	}

	private register() {
		if (!this.payload.contractorId) {
			Notifications.error("Select a contractor from the drop-down list")
			this.hasError = true;
			this.isOpen1 = true;
			this.successful = false;
		} else {
			ifValid(this, () => {
				this.startLoading();
				ForeignContractorService.registerContractor(this.payload).then(
					() => {
						this.stopLoading();
						this.$modal.hideAll();
						this.callback();
					},
					err => this.errorHandling(err)
				)
			})
		}
	}

	private processSelect(person: PersonDTO) {
		this.payload.contractorId = person.id;
	}

	private errorHandling(err: any) {
		console.log(err?.response?.data.param)
		this.successful = false;
		let systemCode = err?.response?.data.systemCode;
		let param = err?.response?.data.param;
		let person: PersonDTO;
		let customerAccounts: CustomerAccounts;
		this.$modal.hide("hide")
		switch (systemCode) {
			case 40023:
			case 40033:
				person = param;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(err),
					{ssn: person.ssn, lastName: person.lastName, firstName: person.firstName, tin: person.nationalTin}) as string;
				break;
			case 40025:
				customerAccounts = param;
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(err),
					{
						lastName: customerAccounts.person?.lastName,
						firstName: customerAccounts.person?.firstName,
						listCompanyNames: this.handleCompaniesName(customerAccounts.companies)
					}) as string;
				break
			default:
				this.message = this.$t(ErrorLocalePathUtils.getPathForError(err), param) as string;
		}
		this.stopLoading();
	}

	private handleCompaniesName(companies: Array<CompanyDTO>): string {
		let res = "";
		for (let i = 0; i < companies.length; i++) {
			res += companies[i].name.concat(i == companies.length - 1 ? "" : ", ");
		}
		return res;
	}
}

